/* cpg-collection.js â€” makes the collection page's finder / facets / sort / pager live.
 * build: vehicle-page-ymm-routing-engine-gate-2026-08-22d
 *
 * Progressive enhancement: the section is server-rendered (SEO + no-JS baseline). On boot
 * this reads the sitewide garage + the URL (?brands=, ?availability=, ?price=, make/model)
 * and calls the SAME catalog API Shop All uses â€” /storefront/catalog/products â€” scoped by
 * collection_id, which the backend resolves to the linked category (or vendor, for brand
 * collection pages). The finder writes the sitewide garage and fires cpg:vehicle-changed, so
 * choosing a vehicle here filters the whole site, exactly like Shop All. */
(function () {
  var root = document.querySelector('.cpg-collection[data-collection-id]');
  if (!root) return;

  var API      = root.dataset.api;
  var COLL_ID  = root.dataset.collectionId;
  var COLL_TITLE = root.dataset.collectionTitle || '';
  var LOGO     = root.dataset.logo || '';
  var KEY      = 'cpg:garage:vehicle';
  // VEHICLE MODE (vehicle pages): the page IS a fixed make/model. The grid is scoped by
  // that vehicle alone (no collection_id / no membership), and a Category facet (main_categories)
  // is added so the shopper narrows by department. Additive â€” normal collection pages leave
  // data-vehicle-mode unset and behave exactly as before.
  var VEHICLE_MODE = root.dataset.vehicleMode === '1';
  var FIXED_MAKE   = root.dataset.fixedMake || '';
  var FIXED_MODEL  = root.dataset.fixedModel || '';
  var q = function (sel) { return root.querySelector(sel); };

  var state = { vendors: [], attrs: {}, moreAttr: {}, main: '', moreCat: false, stock: '', price: '', q: '', sort: 'relevance', page: 1, pageSize: 12, noFit: false,
    // Vehicle-mode refinement (make+model fixed by the page; the shopper narrows to their exact year/trim/engine).
    vYear: null, vSubmodel: null, vEngine: null };

  // â”€â”€ helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var fmt = function (n) { return (n || 0).toLocaleString('en-US'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g,
    function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var ico = function (id, c) { return '<svg class="ico ' + (c || '') + '"><use href="#i-' + id + '"/></svg>'; };
  // Resize Shopify CDN images to the display size. The card photo renders at ~168px, so width=300
  // (â‰ˆ2Ã— for retina) is plenty â€” and it matches the SSR baseline's `image_url: width:300`, so the
  // JS re-render reuses the already-cached image instead of downloading the full 1500â€“3000px original.
  function cdnImg(u, w) {
    if (!u || (u.indexOf('cdn.shopify.com') < 0 && u.indexOf('/cdn/shop') < 0)) return u;
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function money(v) {
    var n = parseFloat(v); if (!isFinite(n)) return { whole: '', cents: '' };
    var p = n.toFixed(2).split('.');
    return { whole: '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), cents: p[1] };
  }

  var PRICE_BUCKETS = {
    under_100:  { label: 'Under $100',     min: null, max: 100 },
    '100_250':  { label: '$100 to $250',   min: 100,  max: 250 },
    '250_500':  { label: '$250 to $500',   min: 250,  max: 500 },
    '500_1000': { label: '$500 to $1,000', min: 500,  max: 1000 },
    over_1000:  { label: 'Over $1,000',    min: 1000, max: null }
  };

  // â”€â”€ the garage (shared sitewide key; URL make/model overrides it) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function garage() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  var URL_VEH = (function () {
    var u = new URLSearchParams(location.search);
    var mk = u.get('make'), md = u.get('model');
    if (!mk || !md) return null;
    var y = parseInt(u.get('year') || '', 10);
    return { year: y || null, make: mk, model: md, submodel: u.get('submodel') || null, engine: u.get('engine') || null };
  })();
  function veh() {
    if (VEHICLE_MODE) return { year: state.vYear, make: FIXED_MAKE, model: FIXED_MODEL, submodel: state.vSubmodel, engine: state.vEngine };
    if (state.noFit) return null;
    var g = garage();
    if (URL_VEH) {
      // The vehicle scope comes from the URL (make/model, rarely engine). The GARAGE is the
      // authoritative engine source (engine is only ever set on the PDP/finder), so when the URL
      // omits engine/submodel and the garage holds the SAME make+model, graft them on — otherwise
      // an engine-specific card is stuck at "select your engine" even after the shopper picked one
      // (the "does not fit" PDP -> Shop parts that fit -> category still-unfiltered bug). A URL that
      // names a DIFFERENT vehicle (shared link) keeps its own values.
      var out = { year: URL_VEH.year, make: URL_VEH.make, model: URL_VEH.model, submodel: URL_VEH.submodel, engine: URL_VEH.engine };
      var sameVeh = g && g.make && g.model &&
        String(g.make).toLowerCase() === String(out.make || '').toLowerCase() &&
        String(g.model).toLowerCase() === String(out.model || '').toLowerCase() &&
        (!out.year || !g.year || String(out.year) === String(g.year));
      if (sameVeh) {
        if (!out.engine && g.engine) out.engine = g.engine;
        if (!out.submodel && g.submodel) out.submodel = g.submodel;
        if (!out.year && g.year) out.year = g.year;
      }
      return out;
    }
    if (!g || !g.make || !g.model) return null;
    // engine carried through so category/collection listings drop wrong-engine parts and rank the
    // exact-engine ones first (the backend fit query already does OR-no-engine, so YMM/YMM+sub parts stay).
    return { year: g.year || null, make: g.make, model: g.model, submodel: g.submodel || null, engine: g.engine || null };
  }
  // MOCKUP 2026-10-02 (owner): fit text always names the full vehicle (year, make, model, trim, engine).
  function vehShort(v) { return [v.year, v.make, v.model, v.submodel, v.engine].filter(Boolean).join(' '); }
  function vehLabel(v) { return [v.year, v.make, v.model].filter(Boolean).join(' '); }
  function fitLabel(v) { return [v.year, v.make, v.model, v.submodel, v.engine].filter(Boolean).join(' '); }
  // Per-part fit state (numeric product id -> FitState) from /fit/bulk for the visible page.
  var fitMap = {};

  // Vehicle page only: when the shopper confirms a YEAR, sync the sitewide garage so the top bar
  // reads "Shopping for {year} {make} {model}". Clearing the year clears the garage. lastGarage is
  // set FIRST so this page's own onGarageChange echo is a no-op (we already reflect the state).
  function syncGarageVehicle() {
    if (!VEHICLE_MODE) return;
    try {
      if (state.vYear) {
        var g = { year: state.vYear, make: FIXED_MAKE, model: FIXED_MODEL, submodel: state.vSubmodel || null, engine: state.vEngine || null };
        var raw = JSON.stringify(g);
        lastGarage = raw;
        localStorage.setItem(KEY, raw);
        window.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: g }));
        document.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: g }));
      } else {
        lastGarage = null;
        localStorage.removeItem(KEY);
        window.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: null }));
        document.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: null }));
      }
    } catch (e) {}
  }

  // â”€â”€ fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function load() {
    var p = new URLSearchParams({ page_size: String(state.pageSize), page: String(state.page) });
    // Vehicle pages scope by make/model ALONE â€” no collection_id (the collection is just a URL
    // container with no membership). Normal category pages still pass collection_id.
    if (!VEHICLE_MODE) { p.set('collection_id', COLL_ID); if (COLL_TITLE) p.set('collection_title', COLL_TITLE); }
    var v = veh();
    if (v) { if (v.year) p.set('year', v.year); p.set('make', v.make); p.set('model', v.model); if (v.submodel) p.set('submodel', v.submodel); if (v.engine) p.set('engine', v.engine); }
    if (state.main) p.set('main', state.main);
    if (state.vendors.length) p.set('vendors', state.vendors.join(','));
    var attrPairs = [];
    Object.keys(state.attrs).forEach(function (k) { (state.attrs[k] || []).forEach(function (v) { attrPairs.push(k + '~' + v); }); });
    if (attrPairs.length) p.set('attrs', attrPairs.join(','));
    if (state.stock) p.set('stock', state.stock);
    if (state.price && PRICE_BUCKETS[state.price]) {
      var pb = PRICE_BUCKETS[state.price];
      if (pb.min != null) p.set('price_min', pb.min);
      if (pb.max != null) p.set('price_max', pb.max);
    }
    if (state.q) p.set('q', state.q);
    if (state.sort !== 'relevance') p.set('sort', state.sort);
    root.classList.add('is-loading');
    fetch(API + '/storefront/catalog/products?' + p.toString())
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        // Option B: on a vehicle page with a YEAR, resolve each visible part precisely (FITS /
        // NEEDS_QUALIFIER(engine) / UNIVERSAL / â€¦) so an engine-specific part waits for the engine
        // while an engine-agnostic one is buyable. Render only after the states are known.
        // Resolve each visible part precisely (FITS / NEEDS_QUALIFIER(engine) / â€¦) whenever we have a
        // vehicle WITH A YEAR â€” both vehicle pages (confirmed year) AND normal category/collection
        // pages with a garage vehicle â€” so an engine-specific part waits for the engine instead of
        // showing a buyable "Fits". Render only after the states are known.
        var _fv = veh();
        if (_fv && _fv.year && d.products && d.products.length) {
          return fetchFitBulk(d).then(function (m) { fitMap = m; render(d); });
        }
        fitMap = {};
        render(d);
      })
      .catch(function () {
        var rows = q('[data-rows]');
        if (rows) rows.innerHTML = '<div class="cpg-empty">We could not load parts just now. Refresh, or try again in a moment.</div>';
      })
      .then(function () { root.classList.remove('is-loading'); });
  }

  // Resolve the visible page's products against the chosen vehicle. Returns {numericPid: FitState}.
  function fetchFitBulk(d) {
    var v = veh();
    var pids = (d.products || []).map(function (p) { return p.id; }).filter(Boolean).slice(0, 250);
    var body = JSON.stringify({
      v: { year: v.year, make: v.make, model: v.model, submodel: v.submodel || undefined, engine: v.engine || undefined },
      pids: pids,
    });
    return fetch(API + '/storefront/fitment/fit/bulk', { method: 'POST', headers: { 'content-type': 'text/plain' }, body: body })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (res) {
        var m = {}, rr = (res && res.results) || {};
        Object.keys(rr).forEach(function (k) { m[k] = rr[k] && rr[k].state; });
        return m;
      })
      .catch(function () { return {}; });   // bulk failure -> pcard falls back to the year-confirmed gate
  }

  var lastData = null;
  function render(d) {
    lastData = d;
    var f = d.facets || {}, v = veh();
    // With a vehicle set, the honest "N of M fit" denominator is the whole category
    // (total_in_scope), NOT f.all (which is vehicle-scoped to the grid = fits+universal).
    var scope = v && d.total_in_scope != null ? d.total_in_scope
      : (f.all != null ? f.all : (d.total_in_scope != null ? d.total_in_scope : d.total));

    // count
    var cnt = q('[data-count]');
    if (cnt) {
      if (VEHICLE_MODE) {
        // Honest fit count (d.total = real vehicle matches); universal parts are shown+badged
        // in the grid but never counted as "fit" (Option A, owner law).
        var uni = (d.total_shown != null ? d.total_shown : d.total) - d.total;
        cnt.innerHTML = '<b>' + fmt(d.total) + '</b> parts fit your ' + esc(vehShort(v)) +
          (uni > 0 ? ' <span class="cpg-count-uni">+ ' + fmt(uni) + ' universal</span>' : '');
      } else {
        cnt.innerHTML = '<b>' + fmt(d.total) + '</b> parts' +
          (d.total !== scope ? ', filtered from <b>' + fmt(scope) + '</b>' : '');
      }
    }

    renderFacets(f, v);
    renderChips(v);

    var rows = q('[data-rows]');
    if (rows) rows.innerHTML = (d.products || []).length
      ? d.products.map(function (p) { return pcard(p, v); }).join('')
      : '<div class="cpg-empty">Nothing matches those filters. Remove one above to widen the search.</div>';

    renderPager(d);
    syncSheet();
  }

  // â”€â”€ facet rail (Brand Â· Price Â· Availability, from the API) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function frow(label, count, key, val, on) {
    return '<a class="cpg-facet__row' + (on ? ' is-on' : '') + '" href="#" data-f="' + key + '" data-v="' + esc(val) + '"' +
      ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="cpg-facet__box">' + (on ? ico('check', 'ico--s') : '') + '</span>' +
      '<span class="cpg-facet__label">' + esc(label) + '</span>' +
      '<span class="cpg-facet__count">' + fmt(count) + '</span></a>';
  }
  function panel(icon, title, inner) {
    return '<div class="cpg-facet"><div class="cpg-facet__head">' + ico(icon) +
      '<span class="cpg-facet__title">' + esc(title) + '</span></div>' +
      '<div class="cpg-facet__list">' + inner + '</div></div>';
  }
  function renderFacets(f, v) {
    var box = q('[data-facets]'); if (!box) return;
    var vend = f.vendors || [], html = '';
    // Vehicle pages: a Category (department) facet FIRST, so the shopper narrows a whole-vehicle
    // scope down to Brakes / Suspension / Exhaust etc. Single-select, key 'main'.
    if (VEHICLE_MODE) {
      var mc = f.main_categories || [];
      if (mc.length) {
        var catN = state.moreCat ? mc.length : 8;
        var crows = mc.slice(0, catN).map(function (x) {
          return frow(x.value, x.count, 'main', x.value, state.main === x.value); }).join('');
        if (mc.length > 8) crows += '<button type="button" class="cpg-facet__more" data-more="moreCat">' +
          (state.moreCat ? 'Show fewer' : 'Show all ' + mc.length + ' categories') + '</button>';
        html += panel('grid', 'Category', crows);
      }
    }
    if (vend.length) {
      var venN = state.moreVend ? vend.length : 6;
      var rows = vend.slice(0, venN).map(function (x) {
        return frow(x.vendor, x.count, 'vendors', x.vendor, state.vendors.indexOf(x.vendor) >= 0); }).join('');
      if (vend.length > 6) rows += '<button type="button" class="cpg-facet__more" data-more="moreVend">' +
        (state.moreVend ? 'Show fewer' : 'Show all ' + vend.length + ' brands') + '</button>';
      html += panel('sell', 'Brand', rows);
    }
    var pb = f.price_buckets || [];
    if (pb.length) {
      html += panel('pay', 'Price', pb.map(function (x) {
        var def = PRICE_BUCKETS[x.key]; if (!def) return '';
        return frow(def.label, x.count, 'price', x.key, state.price === x.key);
      }).join(''));
    }
    var inStock = f.in_stock || 0, all = f.all != null ? f.all : (lastData ? lastData.total_in_scope : 0);
    html += panel('box', 'Availability',
      frow('In stock, ships today', inStock, 'stock', 'in', state.stock === 'in') +
      frow('Backorder', Math.max(0, all - inStock), 'stock', 'backorder', state.stock === 'backorder'));
    // category-specific spec facets (Inlet Type, Position, Materialâ€¦) â€” curated + scoped by the API
    (f.attrs || []).forEach(function (g) {
      var vals = g.values || [];
      if (vals.length < 2) return; // a single-option group can't filter anything
      var sel = state.attrs[g.key] || [];
      var open = !!state.moreAttr[g.key];
      var shown = open ? vals.length : Math.min(vals.length, 6);
      var rows = vals.slice(0, shown).map(function (x) {
        return frow(x.value, x.count, 'attr:' + g.key, x.value, sel.indexOf(x.value) >= 0);
      }).join('');
      if (vals.length > 6) rows += '<button type="button" class="cpg-facet__more" data-more-attr="' + esc(g.key) + '">' +
        (open ? 'Show fewer' : 'Show all ' + vals.length) + '</button>';
      html += panel('tune', g.key, rows);
    });
    box.innerHTML = html;
  }

  function renderChips(v) {
    var chips = [];
    // The vehicle is removable on category pages (a filter); on a vehicle page it IS the page, so no chip.
    if (v && !VEHICLE_MODE) chips.push(['fit', vehShort(v)]);
    if (state.main) chips.push(['main', state.main]);
    state.vendors.forEach(function (v) { chips.push(['vendor:' + v, v]); });
    Object.keys(state.attrs).forEach(function (k) { (state.attrs[k] || []).forEach(function (av) { chips.push(['attrv:' + k + '~' + av, av]); }); });
    if (state.price && PRICE_BUCKETS[state.price]) chips.push(['price', PRICE_BUCKETS[state.price].label]);
    if (state.stock) chips.push(['stock', state.stock === 'in' ? 'In stock' : 'Backorder']);
    if (state.q) chips.push(['q', '"' + state.q + '"']);
    var wrap = q('[data-chips]');
    if (wrap) wrap.innerHTML = chips.map(function (c) {
      return '<a class="cpg-tchip" href="#" data-un="' + c[0] + '">' + esc(c[1]) + ' <span class="x">&times;</span></a>';
    }).join('');
    var clear = q('[data-clear]'); if (clear) clear.hidden = chips.length === 0;
    var badge = q('[data-dock-badge]');
    if (badge) { badge.hidden = chips.length === 0; badge.textContent = chips.length; }
  }

  // â”€â”€ product card (matches the server-rendered .pcard) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function pcard(p, v) {
    var href = '/products/' + esc(p.handle);
    var m = money(p.price);
    var photo = p.image
      ? '<a class="pcard__photo" href="' + href + '" tabindex="-1" aria-hidden="true"><img src="' + esc(cdnImg(p.image, 224)) + '" srcset="' + esc(cdnImg(p.image, 224)) + ' 224w, ' + esc(cdnImg(p.image, 336)) + ' 336w" sizes="(max-width:767px) 112px, 168px" alt="" loading="lazy"></a>'
      : '<a class="pcard__photo pcard__photo--ph" href="' + href + '" tabindex="-1" aria-hidden="true"><img class="pcard__logoph" src="' + esc(LOGO) + '" alt="' + esc(p.title) + '" loading="lazy"></a>';
    var meta = '<span class="pcard__brand">' + esc(p.vendor || '') + '</span>' +
      (p.sku ? '<span class="divider"></span><span class="pcard__sku">SKU ' + esc(p.sku) + '</span>' : '') +
      (p.upc ? '<span class="divider"></span><span class="pcard__sku">UPC ' + esc(p.upc) + '</span>' : '');
    // Fit gate (Option B). Universal / build-spec are always buyable. Otherwise, once a YEAR is
    // chosen the part is resolved per-vehicle via /fit/bulk (fitMap): FITS/FITS_WITH_NOTES ->
    // buyable green; NEEDS_QUALIFIER(engine) -> locked "select your engine"; NO_FIT -> hidden;
    // UNKNOWN -> "verify fitment manually". Before a year: locked "select your year". Normal
    // (category) pages stay gated on the garage vehicle, unchanged.
    var numId = String(p.id || '').replace(/^.*\//, '');
    var st = fitMap[numId];
    var isUni = p.fit_class === 'universal' || p.fit_class === 'build_spec' || st === 'UNIVERSAL' || st === 'BUILD_SPEC';
    var BLUE = 'background:#e8f0fe;color:#1a56db;border:1px solid #bcd0f7;';
    var AMBER = 'background:#fff8e6;color:#8a6100;border:1px solid #f2e0b0;';
    var buyable, lockMsg = '', fitChip;
    if (isUni) {
      buyable = true;
      fitChip = '<span class="pchip" style="' + BLUE + '">' + ((p.fit_class === 'build_spec' || st === 'BUILD_SPEC') ? 'Sold by Spec' : 'Universal Fitment') + '</span>';
    } else if (!v) {
      // No vehicle selected at all (empty garage on a normal collection).
      buyable = false; lockMsg = 'Select your vehicle to see if this part fits';
      fitChip = '<span class="pchip pchip--checkfit">' + ico('help', 'ico--s') + 'Add vehicle to check fit</span>';
    } else if (VEHICLE_MODE && !state.vYear) {
      buyable = false; lockMsg = 'Select your year to confirm fit';
      fitChip = '<span class="pchip" style="' + AMBER + '">' + ico('help', 'ico--s') + 'Select your year to confirm fit</span>';
    } else if (st === 'NO_FIT') {
      return '';   // grid is pre-filtered to fits+universal; guard against a stray non-fitting card
    } else if (st === 'NEEDS_QUALIFIER') {
      // Engine-qualified part + no engine chosen â€” gate ATC on BOTH vehicle pages AND normal
      // category/collection pages (matches the PDP; the shopper confirms the engine on the PDP).
      buyable = false; lockMsg = 'Select your engine to confirm fit';
      fitChip = '<span class="pchip" style="' + AMBER + '">' + ico('help', 'ico--s') + 'Select your engine to confirm fit</span>';
    } else if (st === 'UNKNOWN') {
      buyable = false; lockMsg = 'Verify fitment manually';
      fitChip = '<span class="pchip pchip--checkfit">' + ico('help', 'ico--s') + 'Fit not verified. Confirm part number</span>';
    } else {
      // FITS / FITS_WITH_NOTES, or bulk not yet returned (best-effort at a confirmed year).
      buyable = true;
      fitChip = '<span class="pchip pchip--fits">' + ico('check', 'ico--s') + 'Fits your ' + esc(VEHICLE_MODE ? fitLabel(v) : vehShort(v)) + '</span>';
    }
    buyable = true; // MOCKUP 2026-10-02 (owner): never block — the chip tells the fit, the cart records it
    return '<div class="pcard" data-pid="' + esc(numId) + '">' +
      '<div class="pcard__media">' + photo + '</div>' +
      '<div class="pcard__idn">' +
        '<div class="pcard__meta">' + meta + '</div>' +
        '<a class="pcard__title" href="' + href + '">' + esc(p.title) + '</a>' +
        (function(){var pos=(p.attrs&&p.attrs.Position)?'<span class="pchip" style="background:#111318;color:#fff;border:1px solid #111318;font-weight:700;">'+esc(p.attrs.Position)+'</span>':'';var df=(p.fit_class==='universal'||p.fit_class==='build_spec')?'':'<span class="pchip pchip--type">Direct-fit</span>';return (pos||df)?'<div class="pcard__chips">'+pos+df+'</div>':'';})() +
        '<span class="pcard__stock' + (p.in_stock ? '' : ' is-back') + '"><span class="dot"></span>' +
          (p.in_stock ? 'In stock, ships today' : 'Backorder available') + '</span>' +
        fitChip +
      '</div>' +
      '<div class="pcard__dsc">' +
        (p.snippet ? '<p class="pcard__desc">' + esc(p.snippet) + '</p>' : '') +
        '<div class="pcard__terms">' +
          // Warranty is the REAL per-product term (p.warranty, from custom.warranty via the
          // catalog API) â€” shown only when present, never a hardcoded store-wide claim (2026-08-18).
          (p.warranty ? '<span class="pcard__warranty">' + ico('shield', 'ico--s') + esc(p.warranty) + '</span>' : '') +
          '<span class="pcard__returns">' + ico('return', 'ico--s') + '60-day returns</span>' +
        '</div>' +
      '</div>' +
      '<div class="pcard__buy">' +
        '<div class="pcard__pricegroup"><span class="pcard__price">' + m.whole +
          '<span class="cents">.' + m.cents + '</span></span><span class="pcard__ship">Free shipping</span></div>' +
        '<div class="pcard__actions">' +
          (buyable
            ? '<button type="button" class="pcard__addcart" data-add="' + esc(p.variant_id || '') + '">' + ico('cart') + 'Add to cart</button>'
            : '<span class="pcard__locked">' + ico('lock') + '<span>' + esc(lockMsg || (VEHICLE_MODE ? 'Select your year to confirm fit' : 'Select your vehicle to see if this part fits')) + '</span></span>') +
          '<a class="pcard__details" href="' + href + '" aria-label="View details for ' + esc(p.title) + '"><span class="txt">Full details &amp; fitment</span>' + ico('arrow', 'ico--s') + '</a>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // â”€â”€ pager (windowed) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function renderPager(d) {
    var el = q('[data-pager]'); if (!el) return;
    var size = d.page_size || state.pageSize;
    var shown = (d.total_shown != null ? d.total_shown : d.total) || 0;
    // The catalog API serves pages 1..500 only; past that it returned page 500 again (owner 2026-10-02).
    var realPages = Math.max(1, Math.ceil(shown / size));
    var pages = Math.min(realPages, 500);
    if (pages <= 1) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    var cur = Math.min(state.page, pages);
    var from = Math.max(1, cur - 2), to = Math.min(pages, from + 4);
    from = Math.max(1, Math.min(from, to - 4));
    var html = '<a href="#" class="cpg-pager__step' + (cur <= 1 ? ' is-off' : '') + '" data-page="' + (cur - 1) + '">&lsaquo;</a>';
    if (from > 1) html += num(1, cur) + (from > 2 ? '<span class="cpg-pager__gap">&hellip;</span>' : '');
    for (var i = from; i <= to; i++) html += num(i, cur);
    if (to < pages) html += (to < pages - 1 ? '<span class="cpg-pager__gap">&hellip;</span>' : '') + num(pages, cur);
    html += '<a href="#" class="cpg-pager__step' + (cur >= pages ? ' is-off' : '') + '" data-page="' + (cur + 1) + '">&rsaquo;</a>';
    if (realPages > pages) html += '<span class="cpg-pager__cap" style="flex-basis:100%;text-align:center;font-size:13px;color:#5a6470;margin-top:8px">Showing the first ' + fmt(pages * size) + ' of ' + fmt(shown) + ' parts. Use the filters or search to narrow down.</span>';
    el.innerHTML = html;
  }
  function num(n, cur) {
    return '<a href="#"' + (n === cur ? ' class="is-on" aria-current="page"' : '') + ' data-page="' + n + '">' + fmt(n) + '</a>';
  }

  // â”€â”€ interaction (scoped to the section) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // Refresh the top-bar cart count AND total from the live cart. The theme's own fetch
  // patch refreshes the count but leaves the mini-total ($) stale, so we set both from truth.
  function cpgRefreshHeaderCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var tot = '$' + (c.total_price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      // ONLY the leaf count badges â€” .cpg-tb-m__cart / .cpg-tb__cart-ic hold the SVG icon,
      // so writing textContent there wipes the icon (mobile cart looked broken).
      document.querySelectorAll('.cpg-tb__cart-n, .cpg-tb-m__badge').forEach(function (el) { el.textContent = c.item_count; });
      document.querySelectorAll('.cpg-tb__cart-total').forEach(function (el) { el.textContent = tot; });
    }).catch(function () {});
  }

  // AJAX add-to-cart. We open the theme cart drawer and refresh the header ourselves.
  function addToCart(btn) {
    var id = btn.getAttribute('data-add');
    if (!id || btn.disabled) return;
    if (btn.dataset.orig == null) btn.dataset.orig = btn.innerHTML; // pristine label, even mid-"Added"
    var old = btn.dataset.orig;
    btn.disabled = true; btn.innerHTML = ico('cart') + 'Adding&hellip;';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () {
        if (window.cpgOpenCart) { try { window.cpgOpenCart(); } catch (e) {} }
        cpgRefreshHeaderCart();
        btn.disabled = false; // re-enable NOW so re-adding the same item doesn't need a second click
        btn.innerHTML = ico('check') + 'Added';
        setTimeout(function () { if (btn.innerHTML.indexOf('Added') !== -1) btn.innerHTML = old; }, 1600);
      })
      .catch(function () { btn.innerHTML = old; btn.disabled = false; });
  }

  // â”€â”€ URL fragment routing. Filter state lives in the #hash, NEVER a ?query â€” a fragment
  //    never reaches the server, so these permutations can't be crawled/indexed. Real
  //    category URLs stay path-based. Back/forward handled via popstate.
  var SORTS = ['relevance', 'price_asc', 'price_desc', 'newest', 'in_stock_first'];
  function readHash() {
    var u = new URLSearchParams(location.hash.replace(/^#/, ''));
    var br = u.get('brand'); state.vendors = br ? br.split(',').filter(Boolean) : [];
    state.attrs = {};
    var as = u.get('attrs');
    if (as) as.split(',').forEach(function (pair) { var i = pair.indexOf('~'); if (i > 0) { var k = pair.slice(0, i), val = pair.slice(i + 1); (state.attrs[k] || (state.attrs[k] = [])).push(val); } });
    state.main = u.get('main') || '';
    state.price = (u.get('price') && PRICE_BUCKETS[u.get('price')]) ? u.get('price') : '';
    var st = u.get('stock'); state.stock = (st === 'in' || st === 'backorder') ? st : '';
    state.q = u.get('q') || '';
    var so = u.get('sort'); state.sort = SORTS.indexOf(so) >= 0 ? so : 'relevance';
    state.page = Math.max(1, parseInt(u.get('page') || '1', 10) || 1);
  }
  function writeHash(push) {
    var u = new URLSearchParams();
    if (state.vendors.length) u.set('brand', state.vendors.join(','));
    if (state.main) u.set('main', state.main);
    var ap = [];
    Object.keys(state.attrs).forEach(function (k) { (state.attrs[k] || []).forEach(function (val) { ap.push(k + '~' + val); }); });
    if (ap.length) u.set('attrs', ap.join(','));
    if (state.price) u.set('price', state.price);
    if (state.stock) u.set('stock', state.stock);
    if (state.q) u.set('q', state.q);
    if (state.sort !== 'relevance') u.set('sort', state.sort);
    if (state.page > 1) u.set('page', state.page);
    var h = u.toString();
    var url = location.pathname + location.search + (h ? '#' + h : '');
    try { history[push ? 'pushState' : 'replaceState'](null, '', url); } catch (e) {}
    syncTiles();
  }
  // The category shelf tiles are server-rendered once, so on their own they never know
  // about a brand, stock or price picked in the rail: a click walked to the next category
  // with the filter dropped. Keep them in step. Whenever filter state changes, re-point
  // every tile at the same category carrying the current GLOBAL filters in the #hash,
  // which the destination page already reads on load. Category-specific state (main,
  // attrs, q, page, sort) is deliberately not carried. Merges over any hash a tile
  // already has (brand pages emit #brand=<vendor> themselves), so those keep working.
  var CARRY = ['brand', 'stock', 'price'];
  function syncTiles() {
    var tiles = document.querySelectorAll('.cpg-shelf .cpg-tile');
    if (!tiles.length) return;
    var cur = new URLSearchParams();
    if (state.vendors.length) cur.set('brand', state.vendors.join(','));
    if (state.stock) cur.set('stock', state.stock);
    if (state.price) cur.set('price', state.price);
    for (var i = 0; i < tiles.length; i++) {
      var a = tiles[i];
      var base = a.getAttribute('data-href0');
      if (base == null) { base = a.getAttribute('href') || ''; a.setAttribute('data-href0', base); }
      var hi = base.indexOf('#');
      var path = hi >= 0 ? base.slice(0, hi) : base;
      var u = new URLSearchParams(hi >= 0 ? base.slice(hi + 1) : '');
      for (var c = 0; c < CARRY.length; c++) { if (cur.has(CARRY[c])) u.set(CARRY[c], cur.get(CARRY[c])); }
      var h = u.toString();
      a.setAttribute('href', path + (h ? '#' + h : ''));
    }
  }
  function syncInputs() {
    if (qi) qi.value = state.q;
    if (sortSel) sortSel.value = state.sort;
    if (perSel) perSel.value = String(state.pageSize);
    var dp = q('[data-dock-perpage]'); if (dp) dp.textContent = state.pageSize;
  }
  // a user filter action: push a history entry with the new hash, then fetch
  function commit() { writeHash(true); load(); }
  window.addEventListener('popstate', function () { readHash(); syncTiles(); syncInputs(); load(); });
  // In-page filter links (the vehicle category tiles use href="#main=<name>", the shelf uses
  // "#brand="): a hash link fires hashchange (not popstate). Re-read the hash, reload, and bring
  // the results into view so a tile click at the top of the page visibly narrows the grid below.
  window.addEventListener('hashchange', function () {
    readHash(); syncTiles(); syncInputs(); load();
    var res = q('.cpg-results'); if (res && res.scrollIntoView) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var f = e.target.closest('[data-f]'), un = e.target.closest('[data-un]'),
        cl = e.target.closest('[data-clear]'), pg = e.target.closest('[data-page]'),
        mr = e.target.closest('[data-more]'),
        ma = e.target.closest('[data-more-attr]');
    if (ma) { e.preventDefault(); state.moreAttr[ma.dataset.moreAttr] = !state.moreAttr[ma.dataset.moreAttr]; if (lastData) render(lastData); return; }
    if (mr) { e.preventDefault(); state[mr.dataset.more] = !state[mr.dataset.more]; if (lastData) render(lastData); return; }
    if (pg) {
      e.preventDefault();
      if (pg.classList.contains('is-off')) return;
      state.page = Math.max(1, parseInt(pg.dataset.page, 10) || 1);
      commit();
      var top = q('[data-rows]'); if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (!f && !un && !cl) return;
    e.preventDefault();
    if (f) {
      var fk = f.dataset.f, fv = f.dataset.v;
      if (fk === 'vendors') { var vi = state.vendors.indexOf(fv); if (vi >= 0) state.vendors.splice(vi, 1); else state.vendors.push(fv); }
      else if (fk.indexOf('attr:') === 0) {
        var ak = fk.slice(5), arr = state.attrs[ak] || (state.attrs[ak] = []), aidx = arr.indexOf(fv);
        if (aidx >= 0) { arr.splice(aidx, 1); if (!arr.length) delete state.attrs[ak]; } else arr.push(fv);
      }
      else state[fk] = state[fk] === fv ? '' : fv;
      var _on = f.classList.toggle('is-on'); f.setAttribute('aria-pressed', _on ? 'true' : 'false');
      var _bx = f.querySelector('.cpg-facet__box'); if (_bx) _bx.innerHTML = _on ? ico('check', 'ico--s') : '';
    }
    if (un) {
      var uk = un.dataset.un;
      if (uk === 'fit') state.noFit = true;
      else if (uk.indexOf('vendor:') === 0) { var uvi = state.vendors.indexOf(uk.slice(7)); if (uvi >= 0) state.vendors.splice(uvi, 1); }
      else if (uk.indexOf('attrv:') === 0) { var rest = uk.slice(6), sp = rest.indexOf('~'), rk = rest.slice(0, sp), rv = rest.slice(sp + 1), rarr = state.attrs[rk]; if (rarr) { var ridx = rarr.indexOf(rv); if (ridx >= 0) { rarr.splice(ridx, 1); if (!rarr.length) delete state.attrs[rk]; } } }
      else state[uk] = '';
    }
    if (cl) { state.vendors = []; state.attrs = {}; state.main = ''; state.stock = state.price = state.q = ''; state.noFit = true; var qic = q('[data-q]'); if (qic) qic.value = ''; }
    if (cl && VEHICLE_MODE) {
      // Vehicle mode keeps the fixed make/model; Clear all just drops the year/trim/engine refinement.
      state.vYear = state.vSubmodel = state.vEngine = null; state.noFit = false;
      // Reset the Y/M/M/Submodel finder so a stale make/model can't mis-route on the next GO.
      var _y = q('[data-vm-year]'), _mk = q('[data-vm-make]'), _md = q('[data-vm-model]'), _s = q('[data-vm-submodel]');
      if (_y) _y.value = '';
      if (_mk) { _mk.innerHTML = '<option value="">Select make</option>'; _mk.disabled = true; }
      if (_md) { _md.innerHTML = '<option value="">Select model</option>'; _md.disabled = true; }
      if (_s) { _s.innerHTML = '<option value="">All trims</option>'; _s.disabled = true; }
      if (typeof goState === 'function') goState();
      syncGarageVehicle();   // year cleared -> clear the sitewide garage; cards re-lock
      renderFinder();        // back to the neutral "pick your vehicle" state
    }
    state.page = 1;
    commit();
  });

  // keyword (debounced; scoped)
  var qi = q('[data-q]'), qt = null;
  if (qi) qi.addEventListener('input', function () {
    clearTimeout(qt);
    qt = setTimeout(function () { state.q = qi.value.trim(); state.page = 1; commit(); }, 350);
  });

  // sort + per-page
  var sortSel = q('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function (ev) { state.sort = ev.target.value; state.page = 1; commit(); });
  var perSel = q('[data-perpage]');
  if (perSel) perSel.addEventListener('change', function (ev) {
    state.pageSize = parseInt(ev.target.value, 10) || 12; state.page = 1;
    var dp = q('[data-dock-perpage]'); if (dp) dp.textContent = state.pageSize;
    commit();
  });

  // â”€â”€ mobile Filter & Sort sheet (phones) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // A full-screen overlay. On open we MOVE the live .cpg-rail node into the sheet body so
  // there is exactly one [data-facets] (with the desktop rail's handlers); on close we put
  // it back. Filters apply live as you tap; "Show N results" just closes to reveal them.
  var sheet = q('[data-sheet]');
  var SORT_LABELS = { relevance: 'Featured', price_asc: 'Price: low to high', price_desc: 'Price: high to low', newest: 'Newest', in_stock_first: 'In stock first' };
  var PP = [12, 24, 48];
  var railHome = null;
  function buildSheetControls() {
    var sw = q('[data-sheet-sorts]');
    if (sw) sw.innerHTML = SORTS.map(function (s) {
      return '<button type="button" class="cpg-ssort" data-ssort="' + s + '"><span>' + esc(SORT_LABELS[s] || s) + '</span><span class="rd"></span></button>';
    }).join('');
    var pw = q('[data-sheet-pp]');
    if (pw) pw.innerHTML = PP.map(function (n) {
      return '<button type="button" class="cpg-spp" data-spp="' + n + '">' + n + '</button>';
    }).join('');
  }
  function syncSheet() {
    if (!sheet) return;
    var i, b, sorts = root.querySelectorAll('[data-ssort]');
    for (i = 0; i < sorts.length; i++) { b = sorts[i]; b.classList.toggle('is-on', b.getAttribute('data-ssort') === state.sort); }
    var pps = root.querySelectorAll('[data-spp]');
    for (i = 0; i < pps.length; i++) { b = pps[i]; b.classList.toggle('is-on', parseInt(b.getAttribute('data-spp'), 10) === state.pageSize); }
    var c = q('[data-sheet-count]'); if (c && lastData) c.textContent = fmt(lastData.total_shown != null ? lastData.total_shown : lastData.total);
  }
  function openSheet(where) {
    if (!sheet) return;
    var rail = q('.cpg-rail'), body = q('[data-sheet-body]');
    if (rail && body && rail.parentNode !== body) { railHome = { parent: rail.parentNode, next: rail.nextSibling }; body.appendChild(rail); }
    sheet.hidden = false; sheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    syncSheet();
    var scroll = q('[data-sheet-scroll]'), bodyEl = q('[data-sheet-body]');
    if (scroll) scroll.scrollTop = (where === 'filters' && bodyEl) ? Math.max(0, bodyEl.offsetTop - 56) : 0;
  }
  function closeSheet() {
    if (!sheet) return;
    var rail = q('.cpg-rail');
    if (rail && railHome && railHome.parent) { railHome.parent.insertBefore(rail, railHome.next); railHome = null; }
    sheet.hidden = true; sheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (sheet) {
    buildSheetControls();
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sheet-close]')) { e.preventDefault(); closeSheet(); return; }
      var ss = e.target.closest('[data-ssort]');
      if (ss) { e.preventDefault(); state.sort = ss.getAttribute('data-ssort'); state.page = 1; syncSheet(); commit(); return; }
      var sp = e.target.closest('[data-spp]');
      if (sp) { e.preventDefault(); state.pageSize = parseInt(sp.getAttribute('data-spp'), 10) || 12; state.page = 1; syncInputs(); syncSheet(); commit(); return; }
      if (e.target.closest('[data-sheet-clear]')) {
        e.preventDefault();
        state.vendors = []; state.attrs = {}; state.main = ''; state.stock = state.price = state.q = ''; state.noFit = true;
        var qic = q('[data-q]'); if (qic) qic.value = '';
        state.page = 1; commit();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 767) { var rail = q('.cpg-rail'), body = q('[data-sheet-body]'); if (rail && body && rail.parentNode === body) closeSheet(); }
    });
  }
  var dockF = q('[data-dock-filters]'); if (dockF) dockF.onclick = function () { openSheet('filters'); };
  var dockS = q('[data-dock-sort]'); if (dockS) dockS.onclick = function () { openSheet('sort'); };
  var dockP = q('[data-dock-perpage]'); if (dockP) dockP.onclick = function () { openSheet('sort'); };

  // â”€â”€ the vehicle finder cascade (year â†’ make â†’ model â†’ submodel) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var vmY = q('[data-vm-year]'), vmMk = q('[data-vm-make]'), vmMd = q('[data-vm-model]'),
      vmSm = q('[data-vm-submodel]'), vmGo = q('[data-vm-go]');
  function fill(sel, values, placeholder) {
    if (!sel) return;
    sel.innerHTML = '<option value="">' + placeholder + '</option>' +
      values.map(function (x) { return '<option value="' + esc(x) + '">' + esc(x) + '</option>'; }).join('');
    sel.disabled = values.length === 0;
  }
  function goState() {
    if (!vmGo) return;
    var base = vmY && vmY.value && vmMk && vmMk.value && vmMd && vmMd.value;
    // Vehicle page: the trim is REQUIRED when the vehicle actually HAS trims (the submodel select
    // carries real options); when it has none, GO enables on Year+Make+Model alone.
    var smAvail = VEHICLE_MODE && vmSm && !vmSm.disabled && vmSm.options && vmSm.options.length > 1;
    var smOk = !smAvail || (vmSm && vmSm.value);
    vmGo.disabled = !(base && smOk);
  }
  // Vehicle-page routing map: shop.metafields.cpg.vehicle_pages, { make: [{ model, handle }] },
  // emitted as JSON by the vehicle section. Returns the collection handle for make+model, or null.
  var VP_MAP;
  function lookupVehiclePage(make, model) {
    if (VP_MAP === undefined) {
      VP_MAP = {};
      try { var el = document.querySelector('[data-cpg-vp-map]'); if (el) VP_MAP = JSON.parse(el.textContent || '{}') || {}; } catch (e) { VP_MAP = {}; }
    }
    var mkl = (make || '').toLowerCase(), mdl = (model || '').toLowerCase();
    for (var mk in VP_MAP) {
      if (mk.toLowerCase() !== mkl) continue;
      var arr = VP_MAP[mk] || [];
      for (var i = 0; i < arr.length; i++) { if (arr[i] && (arr[i].model || '').toLowerCase() === mdl) return arr[i].handle; }
    }
    return null;
  }
  function cascade(url, sel, placeholder, keyName) {
    if (sel) sel.disabled = true;
    fetch(API + url).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) { fill(sel, d[keyName] || [], placeholder); })
      .catch(function () { if (sel) sel.innerHTML = '<option value="">' + placeholder + ' unavailable</option>'; });
  }
  if (vmY && vmMk && vmMd && vmGo) {
    cascade('/storefront/fitment/years', vmY, 'Select year', 'years');
    vmY.addEventListener('change', function () {
      fill(vmMk, [], 'Select make'); fill(vmMd, [], 'Select model'); fill(vmSm, [], 'Any'); goState();
      if (vmY.value) cascade('/storefront/fitment/makes?year=' + encodeURIComponent(vmY.value), vmMk, 'Select make', 'makes');
    });
    vmMk.addEventListener('change', function () {
      fill(vmMd, [], 'Select model'); fill(vmSm, [], 'Any'); goState();
      if (vmMk.value) cascade('/storefront/fitment/models?year=' + encodeURIComponent(vmY.value) +
        '&make=' + encodeURIComponent(vmMk.value), vmMd, 'Select model', 'models');
    });
    vmMd.addEventListener('change', function () {
      fill(vmSm, [], 'Any'); goState();
      if (vmMd.value) {
        if (vmSm) vmSm.disabled = true;
        fetch(API + '/storefront/fitment/submodels?year=' + encodeURIComponent(vmY.value) +
          '&make=' + encodeURIComponent(vmMk.value) + '&model=' + encodeURIComponent(vmMd.value))
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (d) { var subs = d.submodels || []; fill(vmSm, subs, (VEHICLE_MODE && subs.length) ? 'Select trim' : 'Any'); goState(); })
          .catch(function () { if (vmSm) { vmSm.innerHTML = '<option value="">Any</option>'; vmSm.disabled = true; } goState(); });
      }
    });
    if (vmSm) vmSm.addEventListener('change', goState);
    vmGo.addEventListener('click', function () {
      if (vmGo.disabled) return;
      if (!(vmY.value && vmMk.value && vmMd.value)) return;
      var v = { year: parseInt(vmY.value, 10) || null, make: vmMk.value, model: vmMd.value, submodel: (vmSm && vmSm.value) || null };
      try { localStorage.setItem(KEY, JSON.stringify(v)); lastGarage = localStorage.getItem(KEY); } catch (e) {}
      try {
        window.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: v }));
        document.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: v }));
      } catch (e) {}
      // VEHICLE PAGE routing: stay on this page ONLY while the make+model still match it; otherwise
      // hand off to that vehicle's own page (cpg.vehicle_pages) or Shop All scoped to it. The garage
      // was just saved above, so the destination restores + auto-narrows to this exact year/trim.
      if (VEHICLE_MODE) {
        var same = v.make && v.model &&
          v.make.toLowerCase() === (FIXED_MAKE || '').toLowerCase() &&
          v.model.toLowerCase() === (FIXED_MODEL || '').toLowerCase();
        if (!same) {
          var handle = lookupVehiclePage(v.make, v.model);
          var dest;
          if (handle) {
            dest = '/collections/' + handle;
          } else {
            var qp = 'year=' + encodeURIComponent(v.year || '') +
              '&make=' + encodeURIComponent(v.make) + '&model=' + encodeURIComponent(v.model);
            if (v.submodel) qp += '&submodel=' + encodeURIComponent(v.submodel);
            dest = '/pages/shop-all?' + qp;
          }
          window.location.href = dest;
          return;
        }
        // same make+model -> narrow THIS page in place to the chosen year/trim
        state.vYear = v.year; state.vSubmodel = v.submodel; state.vEngine = null;
      }
      URL_VEH = null; state.noFit = false; state.page = 1;
      renderFinder();
      load();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // â”€â”€ vehicle-mode refinement: make+model are fixed by the page; the shopper narrows to their
  //    exact year -> trim -> engine. Options + grid both come from the fitment API. NHTSA year
  //    windows live in product_vehicles; only years we actually have parts for are offered (no
  //    dead ends), capped at the current model year. â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  if (VEHICLE_MODE) {
    var vfY = q('[data-vf-year]'), vfSm = q('[data-vf-submodel]'), vfEn = q('[data-vf-engine]');
    var VMM = 'make=' + encodeURIComponent(FIXED_MAKE) + '&model=' + encodeURIComponent(FIXED_MODEL);
    var nowYr = (new Date()).getFullYear();
    // RESTORE a confirmed year from the sitewide garage IF it is THIS vehicle. The header bar does a
    // full reload when the garage changes, so without this a shopper who just picked a year would land
    // back on the locked state. A DIFFERENT saved vehicle does not match, so the page stays neutral.
    (function restoreFromGarage() {
      try {
        var g = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (g && g.make === FIXED_MAKE && g.model === FIXED_MODEL && g.year) {
          state.vYear = parseInt(g.year, 10) || null;
          state.vSubmodel = g.submodel || null;
          state.vEngine = g.engine || null;
        }
      } catch (e) {}
    })();
    // Fill a select from a fitment endpoint, then re-apply a restored value (async option list).
    function fillFrom(sel, path, keyName, placeholder, val) {
      fetch(API + path).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) { fill(sel, d[keyName] || [], placeholder); if (val != null) sel.value = String(val); })
        .catch(function () {});
    }
    if (vfY) {
      // Only years we actually have parts for (from product_vehicles), capped at the current model year.
      fetch(API + '/storefront/fitment/years?' + VMM).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          fill(vfY, (d.years || []).filter(function (y) { return y <= nowYr; }), 'All years');
          if (state.vYear) {
            vfY.value = String(state.vYear);
            fillFrom(vfSm, '/storefront/fitment/submodels?year=' + state.vYear + '&' + VMM, 'submodels', 'All trims', state.vSubmodel);
            fillFrom(vfEn, '/storefront/fitment/vehicle-engines?year=' + state.vYear + '&' + VMM, 'engines', 'All engines', state.vEngine);
          }
        })
        .catch(function () { if (vfY) vfY.innerHTML = '<option value="">All years</option>'; });
      vfY.addEventListener('change', function () {
        state.vYear = vfY.value ? parseInt(vfY.value, 10) : null;
        state.vSubmodel = null; state.vEngine = null;
        fill(vfSm, [], 'All trims'); fill(vfEn, [], 'All engines');
        if (state.vYear) {
          cascade('/storefront/fitment/submodels?year=' + state.vYear + '&' + VMM, vfSm, 'All trims', 'submodels');
          cascade('/storefront/fitment/vehicle-engines?year=' + state.vYear + '&' + VMM, vfEn, 'All engines', 'engines');
        }
        state.page = 1; renderFinder(); syncGarageVehicle(); load();
      });
    }
    if (vfSm) vfSm.addEventListener('change', function () {
      // Submodel is optional and non-gating; the engine list is submodel-independent (VCdb is keyed
      // year+make+model), so changing trim just re-queries the grid â€” it never resets the engine.
      state.vSubmodel = vfSm.value || null;
      state.page = 1; renderFinder(); syncGarageVehicle(); load();
    });
    if (vfEn) vfEn.addEventListener('change', function () {
      state.vEngine = vfEn.value || null; state.page = 1; renderFinder(); syncGarageVehicle(); load();
    });
  }

  // The finder folds into a green "already picked" panel when a vehicle is active
  // (Switch reveals the dropdowns again; Remove clears the vehicle everywhere).
  function renderFinder() {
    var finder = q('[data-cpg-finder]'), active = q('[data-finder-active]');
    if (!finder) return;
    // Vehicle page: NEUTRAL (not green/confirmed) until a year is chosen. The page only knows
    // make+model until then, so the green "these fit" state would over-promise.
    if (VEHICLE_MODE) {
      // Fold to the confirmed bar once a year is chosen; hide BOTH the neutral head and the finder
      // form (the full Y/M/M/Submodel dropdowns). "Change vehicle" (data-finder-switch) re-opens them.
      var vhead = q('[data-finder-head]');
      var vform = q('[data-finder-form]');
      var confirmed = !!state.vYear;
      finder.classList.toggle('cpg-finder--active', confirmed);
      if (vhead) vhead.hidden = confirmed;
      if (vform) vform.hidden = confirmed;
      if (active) active.hidden = !confirmed;
      if (confirmed) {
        var vt2 = q('[data-finder-veh]');
        if (vt2) vt2.textContent = [state.vYear, FIXED_MAKE, FIXED_MODEL, state.vSubmodel].filter(Boolean).join(' ');
      }
      return;
    }
    var v = veh();
    var head = q('[data-finder-head]'), form = q('[data-finder-form]');
    if (!active) return;
    if (v) {
      finder.classList.add('cpg-finder--active');
      if (head) head.hidden = true;
      if (form) form.hidden = true; active.hidden = false;
      var vt = q('[data-finder-veh]');
      if (vt) vt.textContent = [v.year, v.make, v.model, v.submodel, v.engine].filter(Boolean).join(' ');
    } else {
      finder.classList.remove('cpg-finder--active');
      if (head) head.hidden = false;
      if (form) form.hidden = false; active.hidden = true;
    }
  }
  var fSwitch = q('[data-finder-switch]');
  if (fSwitch) fSwitch.addEventListener('click', function () {
    var finder = q('[data-cpg-finder]'), head = q('[data-finder-head]'),
        form = q('[data-finder-form]'), active = q('[data-finder-active]');
    if (finder) finder.classList.remove('cpg-finder--active');
    if (head) head.hidden = false;
    if (form) form.hidden = false;
    if (active) active.hidden = true;
  });
  var fRemove = q('[data-finder-remove]');
  if (fRemove) fRemove.addEventListener('click', function () {
    URL_VEH = null; state.noFit = false; state.page = 1;
    if (VEHICLE_MODE) { state.vYear = null; state.vSubmodel = null; state.vEngine = null; }  // un-narrow back to all years
    lastGarage = null;                       // make onGarageChange's echo a no-op; we drive it here
    try { if (window.CPGFitment && typeof window.CPGFitment.clearVehicle === 'function') window.CPGFitment.clearVehicle(); } catch (e) {}
    try { localStorage.removeItem(KEY); } catch (e) {}
    renderFinder(); load();
  });

  // garage can change from the header bar / another tab / a product page
  var lastGarage = null; try { lastGarage = localStorage.getItem(KEY); } catch (e) {}
  function onGarageChange() {
    var raw = null; try { raw = localStorage.getItem(KEY); } catch (e) {}
    if (raw === lastGarage) return;
    // Vehicle page: scope is fixed to this vehicle + the on-page year; an external garage change
    // (another tab, the header bar) must not re-drive this page. Just track the value.
    if (VEHICLE_MODE) { lastGarage = raw; return; }
    lastGarage = raw; state.noFit = false; state.page = 1; renderFinder(); load();
  }
  window.addEventListener('cpg:vehicle-changed', onGarageChange);
  document.addEventListener('cpg:vehicle-changed', onGarageChange);
  window.addEventListener('storage', function (e) { if (!e.key || e.key === KEY) onGarageChange(); });

  // â”€â”€ boot: seed state from the URL (brand-tile links, shared facet links) then load â”€â”€â”€â”€
  (function seed() {
    readHash(); // filter state from the #hash (crawl-safe)
    // legacy ?query fallback (old brand-tile links / external backlinks), migrated into the hash
    if (!state.vendors.length && !state.price && !state.stock && !state.q) {
      var u = new URLSearchParams(location.search);
      var br = u.get('brands'); if (br) state.vendors = br.split(',').filter(Boolean);
      var av = u.get('availability'); if (av === 'in-stock') state.stock = 'in'; else if (av === 'backorder') state.stock = 'backorder';
      var pr = u.get('price'); if (pr && PRICE_BUCKETS[pr]) state.price = pr;
      var kw = u.get('q'); if (kw) state.q = kw;
      if (state.vendors.length || state.price || state.stock || state.q) writeHash(false);
    }
    syncInputs();
  })();
  syncTiles();
  renderFinder();
  load();
})();
